<template>
  <div>
    <GmapMap
      ref="gmap"
      class="google-map"
      :center="mapCenter"
      :zoom="8"
      :options="mapOptions"
      style="width: 100%; height: 380px"
    >
      <!-- @tilesloaded="onMapLoaded" -->
      <gmap-custom-marker
        v-for="(m, i) in mapMarkers"
        :key="i"
        :marker="m"
      >
        <div
          v-if="i !== 0"
          class="pin-icon-container"
        >
          <div
            class="pin-circle"
            :class="status"
          >
            <Icons :name="`marker-${vehicleModelType}`" />
          </div>
          <div class="pin-arrow" />
        </div>
        <div v-else>
          <v-icon large>
            mdi-map-marker
          </v-icon>
        </div>
      </gmap-custom-marker>

      <!-- polyline -->
      <GmapPolyline
        :path="routeCoordinates"
        :options="polylineOptions"
      />
      <!-- polyline -->
    </GmapMap>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import Vue from "vue";
import VueMqtt from "vue-mqtt";

Vue.use(VueMqtt, "wss://mqtt.flespi.io:443/", {
  clientId: "WebClient-" + parseInt(Math.random() * 100000),
  username: "H0i9Oy5cefXRGGdfNLZLpBt3s7h2h1aPRgOuDIuHLhniLonnXbWaCf3SbaJiZJVE",
});
import GmapCustomMarker from "vue2-gmap-custom-marker";

export default {
  components: {
    GmapCustomMarker,
    Icons: () => import("@/components/base/icons.vue"),
  },
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    optionFilters: {
      type: Object,
      default() {
        return {};
      },
    },
    vehicleModelType: {
      type: String,
      default() {
        return "";
      },
    },
    vehicleBodyType: {
      type: String,
      default() {
        return "";
      },
    },
    status: {
      type: String,
      default() {
        return "";
      },
    },
    height: {
      type: String,
      default() {
        return "365px";
      },
    },
  },
  data() {
    return {
      zoom: 13,
      mapCenter: { lat: 30.3753, lng: 69.3451 },
      mapOptions: {
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: window.google?.maps.ControlPosition.RIGHT_BOTTOM,
        },
      },
      polylineOptions: {
        strokeColor: "#20a390",
        strokeOpacity: 1.0,
        strokeWeight: 4,
      },
      topic: "",
      receviedData: [],
    };
  },
  computed: {
    ...mapGetters({
      vehicleList: "vehicles/getVehiclesList",
    }),
    routeCoordinates() {
      const arr = this.items.map((r) => ({
        lat: parseFloat(r.latitude),
        lng: parseFloat(r.longitude),
      }));
      return arr.concat(this.receviedData);
    },
    mapMarkers() {
      const len = this.routeCoordinates.length - 1;
      const arr = [];
      arr.push(this.routeCoordinates[0]);
      arr.push(this.routeCoordinates[len]);
      return arr;
    },
    MapCenter() {
      const len = this.routeCoordinates.length - 1;
      return this.routeCoordinates[len] ?? [24.8785, 67.0641];
    },
    // bounds() {
    //   const len = this.routeCoordinates.length - 1;
    //   const r = this.routeCoordinates[len];

    //   return latLngBounds([r]);
    // },
  },
  watch: {
    "optionFilters.vehicle_id": {
      handler: function (newVal, oldVal) {
        if (oldVal) {
          const oTopic = this.fetchDeviceId(oldVal);
          this.unsubscribeFromTopic(oTopic);
        }
        if (newVal) {
          // this.topic = this.fetchDeviceId(newVal);
        }
      },
      // immediate: true,
    },
  },
  mounted() {
    this.topic = this.fetchDeviceId(this.optionFilters.vehicle_id);
    this.subscribeToTopic(this.topic);
    this.onMapLoaded();
  },
  beforeDestroy() {
    this.unsubscribeFromTopic(this.topic);
  },
  methods: {
    onMapLoaded() {
      this.$refs.gmap.$mapPromise.then(() => {
        if (window.google && window.google.maps) {
          this.mapOptions.fullscreenControlOptions = {
            position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
          };
        }
        this.setMapBounds();
      });
    },
    setMapBounds() {
      if (!this.routeCoordinates.length) return;
      const bounds = new window.google.maps.LatLngBounds();
      this.routeCoordinates.forEach((coord) => {
        bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
      });
      this.$refs.gmap.$mapObject.fitBounds(bounds);
    },
    subscribeToTopic(val) {
      this.$mqtt.subscribe(val);
    },
    unsubscribeFromTopic(val) {
      this.$mqtt.unsubscribe(val);
    },
    fetchDeviceId(vd) {
      const vr = this.vehicleList.find((r) => r.id == vd);
      return `flespi/message/gw/devices/${vr.device_id}`;
    },
  },
  mqtt: {
    // Handle messages from any topic
    "flespi/message/gw/devices/#"(data) {
      // Wildcard to capture all topics
      const msg = JSON.parse(new TextDecoder().decode(new Uint8Array(data)));
      const { position_latitude, position_longitude } = msg;

      this.receviedData.push({
        lat: position_latitude,
        lng: position_longitude,
      });
    },
  },
};
</script>
<style scoped>
.pin-icon-container {
  position: relative;
  width: 40px;
  height: 60px;
}
.pin-circle {
  width: 40px;
  height: 40px;
  padding: 5px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.pin-arrow {
  position: absolute;
  top: 40px;
  left: 15px;
  width: 10px;
  height: 20px;
  background-color: #ffffff;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}
:deep .active svg path {
  fill: #23bdaa !important;
}
:deep .in_active svg path,
:deep .inactive svg path {
  fill: #ffae20 !important;
}
:deep .offline svg path {
  fill: #fa896b;
}
</style>
